import { TicketStatus } from "@/common/types/support/ticket.type";
import { supportStatusOptions as internalStatusOptions } from "../internal/constants/supportStatusOptions.constant";
import { options as externalStatusOptions } from "../external/constants/statusOptions.constant";
import { SupportTicketTotalizerData } from "../types/supportTicketTotalizer.type";
import { supportTicketsTotalizerClassName } from "./supportTicketsTotalizerClassName.constant";

interface supportTicketsResumeItemsProps {
  data: SupportTicketTotalizerData, 
  kind: 'internal' | 'external'
}

export const supportTicketsResumeItems = ({ data, kind }: supportTicketsResumeItemsProps) => {
  const perStatus = data?.per_status || {};

  const options = kind === 'internal' 
    ? internalStatusOptions 
    : externalStatusOptions;

  const values = options.map((option) => {
    const statusKey = option.value as TicketStatus;

    return {
      label: option.label,
      value: perStatus[statusKey] || 0, 
      textClassName: supportTicketsTotalizerClassName[statusKey] || '',
    };
  });

  return [
    ...values,
    {
      label: "Total",
      value: data?.total || 0,
    },
  ];
};